import React, { useState } from 'react';
import { useStore } from 'react-admin';
import { List, useAuthProvider } from 'react-admin';
import { Container, Tab, Tabs } from '@mui/material';

import { listContainerStyles } from 'src/styles';
import { ShsTitle } from 'src/components/common';
import { UserRole } from 'src/auth/types';
import type { Child } from 'src/components/Children/types';
import { STATUS } from 'src/constants';
import ToolbarActions from './Toolbar';
import Filters from './Filters';
import Grid from './Grid';
import { ChildrenFilterManager } from 'src/managers/Children/ChildrenFilterManager';

const childTopFilterDefaultValues = ChildrenFilterManager.getFiltersDefaultValues();

export const ChildrenList: React.FC = () => {
    const [activeTab, setActiveTab] = useStore<STATUS.ACTIVE | STATUS.INACTIVE>('childrenListTab', STATUS.ACTIVE);

    const [total, setTotal] = useState<number | undefined>(0);
    const authProvider = useAuthProvider();
    const showEducationCenterFilter = authProvider?.containsRoles([UserRole.SYSTEM_ADMIN, UserRole.SECRETARIAT]);

    const currentDate = new Date().toISOString().slice(0, -14);
    return (
        <Container sx={listContainerStyles}>
            <ShsTitle title="Діти" found={total} foundTitle="Загалом" />
            <List<Child>
                resource="children"
                exporter={false}
                empty={false}
                actions={<ToolbarActions />}
                filters={<Filters showEducationCenterFilter={showEducationCenterFilter} />}
                filterDefaultValues={childTopFilterDefaultValues}
                filter={
                    activeTab == STATUS.ACTIVE
                        ? { dateOfEndingGreater: currentDate }
                        : { dateOfEndingLess: currentDate }
                }>
                <Tabs
                    value={activeTab}
                    onChange={(e, value) => {
                        setActiveTab(value);
                    }}>
                    <Tab value={STATUS.ACTIVE} label="Зараз навчаються" />
                    <Tab value={STATUS.INACTIVE} label="Завершили навчання" />
                </Tabs>
                <Grid onTotalChanged={(total) => setTotal(total)} isActiveTabSelected={activeTab === STATUS.ACTIVE} />
            </List>
        </Container>
    );
};
